import { Button, ButtonProps } from 'antd';
import cn from 'classnames';
import { FC } from 'react';
import s from './ButtonSecondary.module.scss';

export const ButtonSecondary: FC<ButtonProps> = props => {
	const { className, ...buttonProps } = props;

	// * Render
	return (
		<Button
			className={cn(s.container, className)}
			type="default"
			{...buttonProps}
		/>
	);
};

/*
! HTML button type is htmlType in Ant design.
! loading true disables the button automatically.
*/
